<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-modal 
        v-model="showUploader"  
        centered
        modal-class="app-popup-shell"
        dialog-class="app-popup-dialog"
        content-class="app-popup-content"
        body-class="app-popup-body"
        :hide-footer= "true"
        size="xl"
        title="" header-class="app-popup-header"
        >
          <galerie-manager :__payload="dataUploaderPayload"></galerie-manager>
        </b-modal>

      <div class="editionPanel">
        <div v-if="__isOnLoad" class="panelLoadingOverlay">
          <b-spinner small variant="primary"></b-spinner>
        </div>
        <div class="row">
          <div class="col-lg-3 col-xl-3 mediaColumn">
            <div class="mediaPanel">
              <div class="mediaPreview" @click="openUploader(false)">
                <img :src="productImageSrc" alt="Produit" class="previewImage" />
              </div>

              <b-button class="mediaButton" @click="openUploader(false)" size="sm">
                {{ hasProductImage ? 'Changer image' : 'Ajouter image' }}
              </b-button>

              <div class="pdfPanel">
                <b-button
                  class="mediaButton"
                  @click="openUploader(true)"
                  v-if="!hasPdfFile"
                  size="sm"
                >
                  Ajouter PDF
                </b-button>

                <div v-else class="pdfPreview">
                  <b-icon
                    font-scale="2.2"
                    icon="file-earmark-pdf-fill"
                    class="pdfIcon"
                    @click="openUploader(true)"
                  ></b-icon>
                  <b-button size="sm" variant="outline-danger" @click="__item.fiche = ''">
                    Retirer PDF
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-9 col-xl-9 fieldsColumn">

             
            <div class="row">
             
              <div class="col-md-4 ">
                Référence
                <base-input
                  placeholder="Référence"
                  v-model="__item.ref"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

            <div class="col-md-8 ">
                Désignation
                <base-input
                  placeholder="Désignation"
                  v-model="__item.name"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-12" v-if="(['ADMIN', 'ROOT'].includes(admin.type))">
                <div class="row">
                  <div class="col-md-4 formGroup" >
                    Prix de revient HT
                    <base-input
                      placeholder="Prix de revient"
                      v-model="__item.prixA"
                      type = "price"
                      :range={min:0}
                      :error = "errorCtrl"
                    >
                    </base-input>
                  </div>

                  <div class="col-md-4 formGroup">
                    Prix de vente HT
                    <base-input
                      placeholder="Prix de vente"
                      v-model="__item.prixV"
                      type = "price"
                      :range={min:0}
                      :error = "errorCtrl"
                    >
                    </base-input>
                  </div>

                  <div class="col-md-4 formGroup">
                    Stock
                    <base-input
                      placeholder="Stock"
                      v-model="__item.stock"
                      type = "num"
                      :error = "errorCtrl"
                    >
                    </base-input>
                  </div>


                </div>
                  
              </div>

              <div class="col-md-6 formGroup">
                  <selector _id="676c8c21590157a748c9c8b6" :_parentItem="__item" _warpper="catID" _customCss="background-color:#F2F2F2; padding: 3%; border-radius: 10px; float: left"></selector>
              </div>

              <div class="col-md-6 formGroup">
                  <selector _id="676c8c8e590157a748c9c8bc" :_parentItem="__item" _warpper="marqueID" _customCss="background-color:#F2F2F2; padding: 3%; border-radius: 10px; float: left"></selector>
              </div>

              <div class="col-md-12 pr-md-1 formGroup" style="text-align: center; margin-bottom: 5px">
                <b-form-textarea
                  id="textarea-small"
                  size="sm"
                  placeholder="Description"
                  v-model="__item.desc"
                ></b-form-textarea>
              </div>
            </div>

            <div class="bottomSummary">
              <div class="summaryCard">
                <div class="summaryHeader">Resume produit</div>
                <div class="summaryBody">
                  <div class="summaryMedia">
                    <img :src="productImageSrc" alt="Produit" class="summaryImage" />
                  </div>
                  <div class="summaryInfo">
                    <div><b>Référence :</b> {{ __item.ref || '-' }}</div>
                    <div><b>Désignation :</b> {{ __item.name || '-' }}</div>
                    <div><b>Catégorie :</b> {{ __item.catID || '-' }}</div>
                    <div><b>Marque :</b> {{ __item.marqueID || '-' }}</div>
                  </div>
                  <div class="summaryStats" v-if="(['ADMIN', 'ROOT', 'COMMERCIAL'].includes(admin.type))">
                    <div><b>Stock reel :</b> {{ __item.stock || 0 }}</div>
                    <div>PUV : <b class="positiveValue">{{ formatMoney(__item.prixV) }}</b> HT</div>
                    <div>Total stock vente : <b class="positiveValue">{{ totalSellValue }}</b> HT</div>
                    <div>PUR : <b class="negativeValue">{{ formatMoney(__item.prixA) }}</b> HT</div>
                    <div>Total stock achat : <b class="negativeValue">{{ totalBuyValue }}</b> HT</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="actionBar">
          <div class="col-md-12" style="margin-top:5px;">
            <b-button size="sm" variant="danger" @click="dispatchCancel()">Fermer</b-button>
            <b-button size="sm" variant="success" @click="dispatchSave()" v-if="(errorCtrl.filter(e => e.isValid === false).length === 0)">Enregistrer</b-button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  components: {

  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => {
    return {
      admin: null,
      _packID: [],
      fullList: [],
      showUploader: false,
      isPDF: false,
      dataUploaderPayload: {
        folder: "prods",
        onFireCB: () => {},
        multiSelection: false,
        customClass: "customCatEditModal",
        acceptTypes: "image/*",
        uploadOptions: {}
      },
      errorCtrl: [],
    }
  },
  methods: {
    onUpdateTpl(tpl) {
      this.$props.__item.template = tpl.data;
    },

    getTof(c) {
      return this.__.resolveMediaPath(c, 'uploads/catalogue/No-Image.jpg');
      // return 'http://localhost:5000/uploads/'+c.split("/uploads/")[1];
      // return './uploads/'+c.split("/uploads/")[1];
    },

    dispatchSave() {
      this.$parent.saveAction();
    },
    dispatchCancel() {
      this.$parent.cancelAction();
    },

    formatMoney(value) {
      return Number(value || 0).toFixed(3);
    },
    syncUploaderPayload() {
      this.dataUploaderPayload.acceptTypes = this.isPDF ? "application/pdf" : "image/*";
      this.dataUploaderPayload.uploadOptions = this.isPDF ? {
        mediaKind: "document"
      } : {
        mediaKind: "image",
        seoEnabled: "true",
        seoPrefix: "produit",
        seoEntity: "product",
        seoName: this.$props.__item.name || "",
        seoRef: this.$props.__item.ref || "",
      };
    },
    openUploader(isPDF = false) {
      this.isPDF = isPDF;
      this.syncUploaderPayload();
      this.showUploader = true;
    },


   

  },
  mounted() {
    this.admin = Vue.$cookies.get("user");
    this.dataUploaderPayload.clientID = '665d03b586d558945dfffa27';
    this.syncUploaderPayload();
    this.dataUploaderPayload.onFireCB = (params) => {
      this.showUploader = false
      if(this.isPDF === true) {
        this.__item.fiche = this.getTof(params[0]);
      } else {
        this.__item.pic = params[0];
      }
     this.isPDF = false
    }
  },

  watch: {
    "__item.name": function () {
      this.syncUploaderPayload();
    },
    "__item.ref": function () {
      this.syncUploaderPayload();
    },
    isPDF: function () {
      this.syncUploaderPayload();
    },
  },

  computed: {
    hasProductImage() {
      return !!this.$props.__item.pic;
    },

    hasPdfFile() {
      return !!this.$props.__item.fiche;
    },

    productImageSrc() {
      return this.getTof(this.$props.__item.pic);
    },

    totalSellValue() {
      return this.formatMoney(Number(this.$props.__item.prixV || 0) * Number(this.$props.__item.stock || 0));
    },

    totalBuyValue() {
      return this.formatMoney(Number(this.$props.__item.prixA || 0) * Number(this.$props.__item.stock || 0));
    },
  },


};
</script>
<style>
.modal-xl {
  max-width: 85% !important;
}
.editionPanel {
    width: 100%;
    padding: 20px;
    margin-bottom: 0;
    border-radius: 14px;
    background-color: #fff;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    max-width: 100%;
    position: relative;
}
.panelLoadingOverlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  z-index: 5;
}
.editionPanel .row {
  margin-left: 0;
  margin-right: 0;
}
.editionPanel [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}
.form-control option {
  color: black;
}
.mediaColumn,
.fieldsColumn {
  margin-bottom: 12px;
  min-width: 0;
}
.mediaPanel {
  background: #f7f8fb;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 14px;
  min-height: 100%;
}
.mediaPreview {
  height: 200px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 10px;
  margin-bottom: 12px;
}
.previewImage {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.mediaButton {
  width: 100%;
  margin-bottom: 10px;
}
.pdfPanel {
  margin-top: 6px;
}
.pdfPreview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #fff4f4;
  border: 1px solid #fecaca;
}
.pdfIcon {
  color: #dc2626;
  cursor: pointer;
}
.formGroup {
  margin-bottom: 10px;
}
.actionBar {
  margin-top: 8px;
  text-align: right;
}
.actionBar .btn + .btn {
  margin-left: 8px;
}
.bottomSummary {
  margin-top: 8px;
}
.summaryCard {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px;
}
.summaryHeader {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  margin-bottom: 10px;
}
.summaryBody {
  display: flex;
  gap: 14px;
  align-items: center;
  flex-wrap: wrap;
}
.summaryMedia {
  width: 72px;
  height: 72px;
  flex: 0 0 72px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.summaryImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.summaryInfo {
  flex: 1 1 auto;
  font-size: 12px;
  color: #334155;
}
.summaryInfo div,
.summaryStats div {
  margin-bottom: 4px;
}
.summaryStats {
  min-width: 190px;
  font-size: 12px;
  color: #334155;
}
.positiveValue {
  color: #16a34a;
}
.negativeValue {
  color: #dc2626;
}
@media (max-width: 991px) {
  .editionPanel {
    padding: 16px;
  }
  .mediaPreview {
    height: 160px;
  }
  .summaryBody {
    flex-direction: column;
    align-items: flex-start;
  }
  .summaryStats {
    min-width: 0;
    width: 100%;
  }
}
</style>

